export enum JourneyType {
  Engineer = 'ENG',
  Mobile = 'MOB',
  MobileVip = 'MOB_VIP',
  Vip = 'VIP', // 3 MONTHS FREE
  Sales = '',
  OFFERUK = 'OFFER', // 4 MONTHS FREE PROMOTION -
}
